import { Controller } from "@hotwired/stimulus"

// Hides a group of slot nudge settings that do not apply to the current choice:
// the whole schedule when the feature is switched off, and the day picker when
// the schedule is daily rather than weekly.
//
// Attached to the input that drives the choice, so it needs no wrapping element.
// data-group is the id of the element to show or hide, and data-show-when is
// either "checked" (for a checkbox) or the select value that reveals the group.
export default class extends Controller {
  connect() {
    this.apply();
  }

  toggle() {
    this.apply();
  }

  apply() {
    const groupId = this.element.dataset.group;
    if (!groupId) return;

    const group = document.getElementById(groupId);
    if (!group) return;

    const showWhen = this.element.dataset.showWhen;
    const visible =
      showWhen === "checked" ? this.element.checked : this.element.value === showWhen;

    group.hidden = !visible;
  }
}
